import { render, staticRenderFns } from "./YandexAuth.vue?vue&type=template&id=a1f27bfe&scoped=true&"
import script from "./YandexAuth.vue?vue&type=script&lang=js&"
export * from "./YandexAuth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1f27bfe",
  null
  
)

export default component.exports